module.exports = __webpack_public_path__ + "static/media/frase_chat.70d73506.svg";